export enum StockMutationTypes {
    LOAD_STOCKS = "LOAD_STOCKS",
    SET_IS_UPLOAD_DONE = "SET_IS_UPLOAD_DONE",
}